module.exports = __webpack_public_path__ + "03_mid_yellow.bdd676fb.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/boy/layer5/03_mid_yellow.png
// module id = bxzz
// module chunks = 0